import { fetchFlowConfig as upstreamFetchFlowConfig } from 'customer-flows/gql/queries/flow-config'
import FlowBootError from 'customer-flows/flow/boot-error'

export default function flowFetch({ stores, callerContext, dispatch }: CommandArgs) {
  const applicationStore: ApplicationStore = stores['application']
  const flowStore: FlowStore = stores['flow']

  /**
   * Fetches the flow config for the current program and registers the program in the store.
   * Pure data fetch — no side effects beyond setting program state.
   * Preflight runs after this to apply business rules derived from the loaded config.
   */
  async function fetchFlowConfig() {
    if (!applicationStore.legacyProgramId) {
      throw new Error('No program ID found in application store')
    }

    flowStore.flowConfig.promise = upstreamFetchFlowConfig(callerContext, { id: applicationStore.legacyProgramId })
      .then((response) => {
        const result = response?.flowConfig

        if (result?.__typename === 'FlowConfigSuccess') {
          return result.flowConfig
        }

        if (result?.__typename === 'NotFoundError') {
          throw new FlowBootError(result.message ?? 'Flow configuration not found', {
            retryable: false,
            reason: 'not-found'
          })
        }

        throw new FlowBootError('Failed to load flow configuration', { retryable: true })
      })
      .catch((error) => {
        if (error instanceof FlowBootError) throw error

        throw new FlowBootError('Failed to load flow configuration', { retryable: true, reason: 'network', cause: error })
      })

    const flowConfig = await flowStore.flowConfig.promise

    if (!flowConfig) {
      throw new FlowBootError('Failed to load flow configuration', { retryable: true })
    }

    dispatch('program:setProgram', flowConfig.program)
    return flowConfig
  }

  return { fetchFlowConfig }
}

declare global {
  export type FlowFetchCommands = ReturnType<typeof flowFetch>

  interface CommandRegistry {
    'flow/fetch': FlowFetchCommands
  }
}
